export default "__VITE_ASSET__ClK_5T5U__"